/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';

import CurrentUser from 'auth/CurrentUser';
import Button from 'components/Button';
import Zopim from 'lib/Zopim';

import type { Status } from 'reducers/zopim';

type Props = {
  children?: React.Element<any>,
  zopimStatus: Status,
};

class ZopimButton extends React.Component<Props> {
  showZopim = () => {
    Zopim.show();
  };

  render() {
    const { children = 'Get live help', zopimStatus, ...props } = this.props;

    if (
      zopimStatus === 'online' &&
      !(CurrentUser.isSignedIn() && CurrentUser.getUser().isUnderage())
    ) {
      return (
        <Button {...props} onClick={this.showZopim}>
          {children}
        </Button>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state: Object) {
  return {
    zopimStatus: state.zopim.status,
  };
}

export { ZopimButton };
export default connect(
  mapStateToProps,
  undefined
)(ZopimButton);
